import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UserHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);

  // ✅ Fetch user ID from localStorage once
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUserId = localStorage.getItem("user_id");

    if (!token || !storedUserId) {
      console.error("❌ Token or User ID missing.");
      setError("User not authenticated.");
      setLoading(false);
    } else {
      setUserId(storedUserId); // 🟢 This was missing!
    }
  }, []);

  // ✅ Fetch match history once userId is available
  useEffect(() => {
    if (!userId) return;

    axios
      .get(`https://backend.aubattle.com/api/history/user/${userId}`)
      .then((res) => {
        setHistory(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching user match history:', err);
        setError('Failed to fetch match history');
        setLoading(false);
      });
  }, [userId]);

  return (
    <div style={{ padding: '2rem' }}>
      <h2>User Match History</h2>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : history.length === 0 ? (
        <p>No match history found.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Match Name</th>
              <th>Match Date</th>
              <th>Slot Number</th>
              <th>Result</th>
              <th>Joined At</th>
            </tr>
          </thead>
          <tbody>
            {history.map((row, i) => (
              <tr key={i} style={{ textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                <td>{row.title}</td>
                <td>{new Date(row.match_date).toLocaleString()}</td>
                <td>{row.slot_number}</td>
                <td style={{ color: row.is_winner ? 'green' : 'red' }}>
                  {row.is_winner ? 'Won' : 'Lost'}
                </td>
                <td>{new Date(row.joined_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserHistory;
